import { render, staticRenderFns } from "./ScoreHeader.vue?vue&type=template&id=2ac3884a&scoped=true&"
import script from "./ScoreHeader.vue?vue&type=script&lang=js&"
export * from "./ScoreHeader.vue?vue&type=script&lang=js&"
import style0 from "./ScoreHeader.vue?vue&type=style&index=0&id=2ac3884a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac3884a",
  null
  
)

export default component.exports